
import './_terms.scss';
import { useNavigate } from 'react-router-dom'


const ReferralTerms = () => {
  const navigate = useNavigate()

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
             Referral Program Terms
            </h2>
            <div className="pf-page__descr">
            <p>
              These referral program terms are additional terms that apply if you use the 
              AllFans referral program (“AllFans Referral Program”). 
              These referral program terms form part of your agreement with us.
            </p>
            </div>
                    <ol className="pf-main-list">
            <li>
              <h5>Definitions</h5>
              <p>In these referral program terms, defined terms have the same 
                meanings given to them in the <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a>. In addition:</p>
              <p>
                <strong>“Referred Creator”</strong> means the person who joins 
                AllFans as a Creator through the Referring User’s unique referral link.
              </p>
              <p>
                <strong>“Referring User”</strong> means “you” or “your.”
              </p>
            </li>
            <li>  
              <h5>AllFans Referral Program</h5>
              <p>
                AllFans offers a referral program by which existing Users can 
                introduce people who are interested in becoming Creators on AllFans 
                and receive referral payments from AllFans that are calculated and 
                limited as described in these terms.
              </p>
            </li>
            <li>
              <h5>AllFans Referral Program Rules</h5>
                <ol>
                  <li>
                    Only Users of AllFans with a current User account can participate 
                    in the AllFans Referral Program. If a User’s account has been suspended 
                    or terminated by us for any reason or deleted by the User, that User will not be eligible 
                    to participate in the AllFans Referral Program.
                  </li>
                  <li>
                    You will need to add on your User account page payment method details to receive 
                    referral payments under the AllFans Referral Program.
                  </li>
                  <li>
                    Each User has a unique referral link (which can be accessed through the User’s User 
                    account) that the User may share with others. When sharing your unique referral link, 
                    you must not impersonate AllFans or give the impression that your referral 
                    link is being shared or promoted by us. You must not use Google Ads or any similar 
                    advertising platform or search engine advertising service to share or promote your unique 
                    referral link. On our request, you must disclose the methods by which you share your 
                    unique referral link in the Bio/Website field of your AllFans account.
                  </li>
                  <li>
                    The Referred Creator must click on your unique referral link and then register with 
                    AllFans using the same browser that they used to click on your unique referral link. 
                    If someone registers with AllFans other than by using your unique referral link, we 
                    will not link that account to your referral and no referral payments will be made to you.
                  </li>
                  <li>
                    The Referred Creator must not have opened a User account with AllFans (whether 
                    under the same name or another name) before clicking on your unique referral link. If the 
                    Referred Creator is currently or has previously been a User of AllFans, no 
                    referral payments will be made to you for the referral.
                  </li>
                  <li>
                    If the Referred Creator sets up more than one User account, we will make referral 
                    payments to you on the earnings made by the Referred Creator from their first User 
                    account only. No referral payments will be made to you on any further User accounts set 
                    up by the Referred Creator.
                  </li>
                  <li>
                    We will not pay any referral payments to you on any referral of a Referred Creator 
                    that we determine is owned or operated by you or is in a commercial relationship with you. 
                    You will provide any information that we request to allow us to determine whether the 
                    Referred Creator is owned or operated by you or if there is a commercial relationship 
                    between you and the Referred Creator.
                  </li>
                  <li>
                    When promoting AllFans in any way as a Referring User:
                      <ul>
                        <li>
                          you must not give a false impression of AllFans, the services, programs, 
                          and content (including Content) made available through AllFans, its Users, 
                          or the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a>; and
                        </li>
                        <li>
                          you must not make any statements that suggest to a potential Creator that the 
                          potential Creator will make a particular sum of money (or any money) from their 
                          use of AllFans, or any statements regarding the likely number of Fans.
                        </li>
                      </ul>
                  </li>
                </ol>
              </li>
              <li>
                <h5>AllFans Referral Program Rules</h5>
                <ul>
                  <li>
                    Once a Referred Creator has become a registered User of AllFans in 
                    accordance with the rules of the AllFans Referral Program, we will pay the 
                    Referring User 5% of Fan Payments generated by the Referred Creator in the 12 months after 
                    the date on which the Referred Creator becomes a registered User of AllFans, 
                    up to a maximum referral payment by AllFans to the Referring User of $75,000 
                    for each Referred Creator.
                  </li>
                  <li>
                    All referral payments payable to Referring Users by us are inclusive of any Taxes.
                  </li>
                  <li>
                    To receive referral payments, you must first choose one of the payout methods 
                    provided by AllFans in your country of residence.
                  </li>
                  <li>
                    The referral payments due to you on Fan Payments made to the Referred Creator in a 
                    calendar month will be transferred to you on or around the first day of the next calendar 
                    month (which means, for example, that referral payments due to you for Fan Payments made 
                    to the Referred Creator in May will be paid to you on or around June 1).
                  </li>
                  <li>
                    Once a Referred Creator has become a registered User of AllFans in 
                    accordance with the rules of the AllFans Referral Program, we will pay the 
                    Referring User 5% of Fan Payments generated by the Referred Creator in the 12 months after 
                    the date on which the Referred Creator becomes a registered User of AllFans, 
                    up to a maximum referral payment by AllFans to the Referring User of $75,000 
                    for each Referred Creator.
                  </li>
                  <li>
                    AllFans, not the Referred Creator, bears the cost of the referral payment.
                  </li>
                </ul>
              </li>
              <li>
                <h5>AllFans’s Rights relating to the Referral Program</h5>
                <ul>
                  <li>
                    If referral payments have been made incorrectly, we may recover the wrongly paid 
                    sums from the User to whom the wrongly paid sums have been paid.
                  </li>
                  <li>
                    We may request you or Referred Creators or both to provide us with ID 
                    and other information reasonably required by us to verify any referral payment to be 
                    made and the person to whom any referral payment should be made. Failure to provide 
                    any information requested by us may lead to you losing your entitlement to referral 
                    payments for the relevant Referred Creator.
                  </li>
                  <li>
                    We may change any aspect of the AllFans Referral Program (including 
                    how referral payments are calculated) or discontinue the AllFans Referral 
                    Program at any time, but no change will deprive any Referring User of referral payments 
                    already earned based on Fan Payments made to Referred Creators before the changes take effect.
                  </li>
                </ul>
              </li>
              <li>
                <h5>Right to Withhold Referral Payments</h5>
                <ul>
                  <li>
                    We may withhold any part of the referral payments due to you but not yet paid out: 
                    (1) if we think that you have or might have materially or repeatedly breached any part of 
                    the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a>; (2) if you attempt or threaten to breach any 
                    part of the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a> in a way that has or could have serious 
                    consequences for us or another User (including actual or possible loss caused to us or 
                    another User); or (3) if we suspect that any part of the referral payments due to you result 
                    from unlawful or fraudulent activity, either by you, by the Fan who made the Fan Payment to 
                    the Referred Creator that resulted in the referral payment, or by the Referred Creator to 
                    whom the Fan Payment was made that resulted in the referral payment, for as long as is 
                    necessary to investigate the actual, threatened, or suspected breach(es) by you or the 
                    suspected unlawful or fraudulent activity (as applicable). If after our investigation, we 
                    conclude that (1) you have materially or repeatedly breached any part of the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a>; (2) you have attempted or threatened to breach any part of 
                    the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a> in a way that has or could have serious 
                    consequences for us or another User (including actual or possible loss caused to us or 
                    another User); or (3) any part of referral payments due to you result from unlawful or 
                    fraudulent activity, we may notify you that you have forfeited all or part of your referral 
                    payments.
                  </li>
                  <li>
                    We may also withhold all or part of the referral payments due to you but not yet paid out 
                    if we receive notice that you have secured, encumbered, pledged, assigned, or otherwise allowed 
                    a lien to be placed on, referral payments. We are not required to pay referral payments to 
                    nonparty lienholders and may withhold payment of Creator Earnings until the lien has been 
                    removed.
                  </li>
                  <li>
                    We are not liable to you if we withhold or forfeit any payment due to you under the 
                    AllFans Referral Program where we have a right to do so under these terms.
                  </li>
                  <li>
                    If we are withholding all or part of the referral payments due to you and we determine 
                    that part of the referral payments withheld by us is unrelated to breaches by you of the 
                    <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a> or suspected unlawful or fraudulent activity, then 
                    we may arrange for you to be paid the part of the referral payments that is unrelated to 
                    breaches by you of the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a> or suspected unlawful or 
                    fraudulent activity. But if we consider that your breaches of the <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms') }} className='terms-link'>Terms of Service</a> or <a href="/creatorterms" onClick={(e) => { e.preventDefault(); navigate('/creatorterms') }} className='terms-link'>Creator Terms</a> has or might cause us loss, we may withhold all referral payments due 
                    to you but not yet paid and we may set off those amounts against any losses suffered by us.
                  </li>
                </ul>
              </li>
            </ol>
            <div style={{ paddingTop: '220px' }}></div>
          </div>
          </div>
          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default ReferralTerms;
